// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__b9obJ","modalFooterButton":"ModalNotes_modalFooterButton__1JibS"};